import React from 'react';
import { FaCcDiscover, FaCcMastercard, FaCcVisa } from 'react-icons/fa';

const CreditCardLogo = ({ brand }: { brand: string }) => {
  return (
    <div className="flex h-[2.4rem] w-[2.4rem] items-center text-[2.4rem]">
      {brand.toLowerCase() === 'mastercard' && <FaCcMastercard />}
      {brand.toLowerCase() === 'visa' && <FaCcVisa />}
      {brand.toLowerCase() === 'discover' && <FaCcDiscover />}
    </div>
  );
};

export default CreditCardLogo;
